import { createI18n } from 'vue-i18n'
import zhCN from '@/lang/zh-CN.js'
import zhTW from '@/lang/zh-TW.js'
import en from '@/lang/en.js'
import ms from '@/lang/ms.js'
import id from '@/lang/id.js'

// 支持的语言配置
const messages = {
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  'en': en,
  'ms': ms,
  'id': id
}

// 创建i18n实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: localStorage.getItem('locale') || 'zh-CN', // 默认语言，优先从本地存储获取
  fallbackLocale: 'zh-CN', // 回退语言
  messages,
})

export default i18n